import * as React from 'react';
import TagComponent from '../../../Common/Tag';
import { Tag } from '../../../../models';
import './style.css';

export interface VideoTagProps {
  doNotLinkTag?: boolean;
  tag: Tag;
  tooltip?: string;
}

export interface VideoTagState {
  /* empty*/
}

export class VideoTag extends React.Component<VideoTagProps, VideoTagState> {
  render() {
    const { children, doNotLinkTag = false, tag, tooltip } = this.props;

    return (
      <TagComponent
        className="video-tag"
        colour={tag.color}
        href={doNotLinkTag ? undefined : `/search?tags=${tag.name}`}
        text={tag.name}
        tooltip={tooltip}
      >
        {children}
      </TagComponent>
    );
  }
}

export default VideoTag;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoTags/VideoTag/index.tsx